import script from "./tool-header-search.vue?vue&type=script&setup=true&lang=ts"
export * from "./tool-header-search.vue?vue&type=script&setup=true&lang=ts"

import "./tool-header-search.vue?vue&type=style&index=0&id=bc39100e&lang=scss"

const __exports__ = script;

export default __exports__